import React, { useState } from "react";
import { Modal } from "../../organismes/ModalCard/ModalCard";
import TextInput from "../../atoms/TextInput/TextInput";
import Button from "../../atoms/Button/Button";
import styles from "./DeleteFilePasswordModal.module.scss";

export interface DeleteFilePasswordModalProps {
  onClose: () => void;
  onConfirm: (password: string) => void;
  isLoading?: boolean;
  error?: string | null;
}

export default function DeleteFilePasswordModal({
  onClose,
  onConfirm,
  isLoading,
  error,
}: DeleteFilePasswordModalProps) {
  const [password, setPassword] = useState("");

  const handleConfirm = () => {
    if (!password || isLoading) return;
    onConfirm(password);
  };

  return (
    <Modal onClose={onClose}>
      <div className={styles["container"]}>
        <h2 className={styles["title"]}>Supprimer le fichier</h2>
        <p className={styles["description"]}>
          Action réservée aux administrateurs. Saisissez le mot de passe pour confirmer la suppression.
        </p>
        <TextInput
          label="Mot de passe"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Mot de passe"
          error={!!error}
        />
        {error && <p className={styles["error"]}>{error}</p>}
        <div className={styles["actions"]}>
          <Button label="Annuler" variant="gray" onClick={onClose} disabled={isLoading} />
          <Button
            label="Supprimer"
            variant="red"
            onClick={handleConfirm}
            disabled={!password || isLoading}
            isLoading={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
}
